// extracted by mini-css-extract-plugin
export default {"banner":"offline-banner_banner__1itls","dot":"offline-banner_dot__pNcZt","pulse":"offline-banner_pulse__bYB9a"};